// src/components/ui/CopyButton.jsx
import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

export default function CopyButton({
  text,
  className = "",
  size = 16,
  label = "Copiar",
  successMs = 1200,
}) {
  const [done, setDone] = useState(false);

  const onCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      // Intento moderno
      await navigator.clipboard.writeText(String(text ?? ""));
      setDone(true);
      setTimeout(() => setDone(false), successMs);
    } catch {
      // Fallback para http / permisos restringidos
      const ta = document.createElement("textarea");
      ta.value = String(text ?? "");
      ta.setAttribute("readonly", "");
      ta.style.position = "absolute";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      setDone(true);
      setTimeout(() => setDone(false), successMs);
    }
  };

  return (
    <button
      type="button"
      onClick={onCopy}
      title={label}
      aria-label={label}
      className={
        "inline-flex items-center justify-center rounded-md border border-gray-300 " +
        "bg-white hover:bg-gray-50 text-gray-700 p-1.5 transition " +
        className
      }
    >
      {done ? <Check size={size} className="text-emerald-600" /> : <Copy size={size} />}
    </button>
  );
}
